import { makeStyles, alpha } from '@material-ui/core';
import commonStyles from 'config/commonStyles';
import { theme } from 'config/theme';

export const useStyles = makeStyles({
    ...commonStyles,
    reservationsRoot: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        backgroundColor: theme.palette.common.white,
    },
    tabWithBadge: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
    tabBadge: {
        minWidth: 20,
        height: 20,
        lineHeight: '20px',
        padding: '0 6px',
        boxSizing: 'border-box',
        borderRadius: 10,
        fontSize: 12,
        letterSpacing: 0,
        color: theme.palette.common.white,
        backgroundColor: theme.palette.error.light,
    },
    contactJamesTeamContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '80vh',
        textAlign: 'center',
        '& h1': {
            fontSize: '24px',
            lineHeight: '36px',
            color: '#5B5858',
        },
        '& h3': {
            width: 650,
            fontSize: '16px',
            lineHeight: '24px',
            color: '#5B5858',
            marginTop: 0,
            fontWeight: 400,
        },
    },
});
